import * as T from './types';

export function showAuth(formType) {
  return dispatch => dispatch({ type: T.SHOW_AUTH_MODAL, formType });
}

export function hideAuth() {
  return dispatch => dispatch({ type: T.HIDE_AUTH_MODAL });
}
